import {Component, Inject} from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';

@Component({
  selector: 'request-dialog',
  templateUrl: './request-dialog.html'
})
export class RequestDialog {
  requestSegment:FormGroup;
  questionid:0;

  constructor(
    public dialogRef: MatDialogRef<RequestDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.questionid=data.questionid;
    }

  get emailError():string {
    if(this.requestSegment.controls['email'].dirty || this.requestSegment.controls['email'].touched) {
      return !!this.requestSegment.controls['email'].errors ? 'A valid email is required' : '';
    }
    return '';
  }

  get bodyError():string {
    if(this.requestSegment.controls['body'].dirty || this.requestSegment.controls['body'].touched) {
      return !!this.requestSegment.controls['body'].errors ? 'Please include a message for the recipient' : '';
    }
    return '';
  }

  ngOnInit() {
    var init={};
    init['email']=new FormControl('',[Validators.required,Validators.email]);
    init['body']=new FormControl('',[Validators.required]);
    this.requestSegment=new FormGroup(init);
  }

  onSave(): void {
    const {value, valid} = this.requestSegment;
    if(valid){
        this.dialogRef.close(value);
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/request-dialog.ts